// Generated by CoffeeScript 1.9.1
var canexecute, isquery;

isquery = require('./isquery');

canexecute = function(exe, query) {
  var key, value;
  if (typeof query !== 'object') {
    return true;
  }
  if (isquery(query) && (exe.providers[query.__q] == null)) {
    return false;
  }
  for (key in query) {
    value = query[key];
    if (!canexecute(exe, value)) {
      return false;
    }
  }
  return true;
};

module.exports = canexecute;
